/**
 * EffortWorkTypeBadges Component
 *
 * Displays effort and work type badges for recommendations.
 */

import type { UnifiedEffort, UnifiedWorkType } from "@a7y/types";

interface EffortWorkTypeBadgesProps {
  effort: UnifiedEffort;
  workType: UnifiedWorkType;
  className?: string;
}

const effortColors: Record<UnifiedEffort, string> = {
  Low: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
  Medium: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400",
  High: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
};

const workTypeColors: Record<UnifiedWorkType, string> = {
  "ASO-Executable": "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  "Dev-Required": "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
  Strategic: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400",
  "Strategic-Insight": "bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300",
};

const workTypeLabels: Record<UnifiedWorkType, string> = {
  "ASO-Executable": "ASO-Executable",
  "Dev-Required": "Dev-Required",
  Strategic: "Strategic",
  "Strategic-Insight": "Insight",
};

export function EffortWorkTypeBadges({ effort, workType, className = "" }: EffortWorkTypeBadgesProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${effortColors[effort]}`}>
        {effort}
      </span>
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${workTypeColors[workType]}`}>
        {workTypeLabels[workType]}
      </span>
    </div>
  );
}
